import features from '~/constants/features';
import { getI18n, Trans } from 'react-i18next';
import React from 'react';

export interface IError {
  title: string;
  description: React.ReactNode[];
  button: {
    text: string;
    onClickLink: 'HOME' | 'BACK';
  };
}

const t = (text: string) => getI18n().t(text, { ns: 'ksaOnboarding' });

export const errors: Record<string, IError> = {
  default: {
    title: t('Something went wrong :('),
    description: [t('Please try again later.')],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  COMPANY_NOT_ACTIVE: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="COMPANY_NOT_ACTIVE"
        t={t}
        i18nKey="The company’s commercial registration is invalid. Please check if the CR number or Company Entity number is entered correctly. <1>Contact us</1> in case of any questions."
      >
        {`The company’s commercial registration is invalid. Please check if the CR number or Company Entity number is entered correctly. `}
        <a href={features.contactUsLink} target="__blank">
          Contact us
        </a>
        {` in case of any questions.`}
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  COMPANY_RELATION: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="COMPANY_RELATION"
        ns="ksaApplication"
        i18nKey="COMPANY_RELATION"
      >
        National ID / Iqama is not associated with the company structure.
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  APPLICATION_USER_ALREADY_EXIST: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="APPLICATION_USER_ALREADY_EXIST"
        t={t}
        i18nKey="A user with this document is already linked to the company’s started application at Network International Saudi Arabia. Please log in with the email used earlier to link to this application or check if the ID type and number are entered correctly. <1>Contact us</1> in case of any questions."
      >
        {`A user with this document is already linked to the company’s started application at Network International Saudi Arabia. Please log in with the email used earlier to link to this application or check if the ID type and number are entered correctly. `}
        <a href={features.contactUsLink} target="__blank">
          Contact us
        </a>
        {` in case of any questions.`}
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  ELM_VERIFICATION: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="ELM_VERIFICATION"
        t={t}
        i18nKey="A record at the National Information Center corresponding to the entered personal data is not found to ensure the authenticity of the document provided during the registration. Please check if the ID type, ID number and Date of birth are entered correctly. <1>Contact us</1> in case of any questions."
      >
        {`A record at the National Information Center corresponding to the entered personal data is not found to ensure the authenticity of the document provided during the registration. Please check if the ID type, ID number and Date of birth are entered correctly. `}
        <a href={features.contactUsLink} target="__blank">
          Contact us
        </a>
        {` in case of any questions.`}
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  CHALLENGE_FAILED_ATTEMPT: {
    title: t('Invalid OTP'),
    description: ['Invalid OTP code is provided. Please check the code and try again.'],
    button: {
      text: t('Try again'),
      onClickLink: 'BACK',
    },
  },
  CHALLENGE_MISMATCH: {
    title: t('Invalid OTP'),
    description: [
      'Invalid OTP code is provided and no attempts are left. Please complete a company and personal data and try again.',
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  CHALLENGE_EXPIRED: {
    title: t('Invalid OTP'),
    description: [
      'The OTP code is expired. Please complete a company and personal data and try again.',
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  MOBILE_VERIFICATION_INVALID_NUMBER: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="MOBILE_VERIFICATION_INVALID_NUMBER"
        t={t}
        i18nKey="The details are invalid. Please check if the ID number and phone number are entered correctly. <1>Contact us</1> in case of any questions."
      >
        {`The details are invalid. Please check if the ID number and phone number are entered correctly. `}
        <a href={features.contactUsLink} target="__blank">
          Contact us
        </a>
        {` in case of any questions.`}
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  MOBILE_VERIFICATION_NOT_OWNER: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="MOBILE_VERIFICATION_NOT_OWNER"
        ns="ksaApplication"
        i18nKey="MOBILE_VERIFICATION_NOT_OWNER"
      >
        Mobile number is not associated with the provided National ID / Iqama
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
  MOBILE_VERIFICATION_INVALID_ID: {
    title: t('Something went wrong :('),
    description: [
      <Trans
        key="MOBILE_VERIFICATION_INVALID_NUMBER"
        t={t}
        i18nKey="The details are invalid. Please check if the ID number and phone number are entered correctly. <1>Contact us</1> in case of any questions."
      >
        {`The details are invalid. Please check if the ID number and phone number are entered correctly. `}
        <a href={features.contactUsLink} target="__blank">
          Contact us
        </a>
        {` in case of any questions.`}
      </Trans>,
    ],
    button: {
      text: t('Try again'),
      onClickLink: 'HOME',
    },
  },
};
